import Videos from './video';

var video = {
    init: function() {
        video.create();
    },
    create: function() {
        const videoEls = document.querySelectorAll('[data-video-element]');
        if (!videoEls.length) return;

        const videos = new Videos();
        const $videoEls = Array.from(videoEls).map(el => $(el));
        let isYoutube = false;
        $videoEls.forEach($video => {
            videos.add($video);
            if($video.is('[data-video-type="youtube"]')) {
                isYoutube = true;
            }
        });

        videos.loadApi(isYoutube);
    }
}

video.init();